import type { DivisionExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const divideResolver =
  createSimpleNamedExpressionResolver<DivisionExpression>(
    'divide',
    (dividend, divisor) => (divisor > 0 ? dividend / divisor : NaN)
  );
